import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput, Loading } from "common-import/custom";
import { inject, observer } from "mobx-react";

import { TimeHelper, VarHelper } from "common-import/helpers"

@inject("projectStore", "userStore", "masterStore") @observer
class AnswerList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      keyword: "",
      page: 1
    };
  };

  async componentDidMount() {
    const { projectStore } = this.props;
    await this.props.userStore.onReady();
    await projectStore.getListAnswer();
    this.setState({isLoading: false})
  }

  renderRow = (data, index) => {
    return (
      <tr key={"row"+index}>
        <td>
          <Link to={`/projects/answer/${data.id}`}>
            <div><strong>{data.id}</strong></div>
          </Link>
        </td>
        <td>
          {
            !!data.createdByUserId ?
              <Link target="_blank" to={`/user/${data.createdByUserId}`}>
                <div><strong>{data.createdByUserId}</strong></div>
              </Link>
              : 'Anonymous'
          }
        </td>
        <td>{moment(data.createdAt).format('ll')}</td>
      </tr>
    )
  };

  render() {
    const { isLoading } = this.state;
    const { projectStore } = this.props;
    const listAnswer = projectStore.listAnswer.slice();
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        {/*<Form onSubmit={this.search}>*/}
          {/*<FormGroup row>*/}
            {/*<Col md="12">*/}
              {/*<InputGroup>*/}
                {/*<InputGroupAddon addonType="prepend">*/}
                  {/*<Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"> </i> Search</Button>*/}
                {/*</InputGroupAddon>*/}
                {/*{makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm dự án đã duyệt" />)}*/}
              {/*</InputGroup>*/}
            {/*</Col>*/}
          {/*</FormGroup>*/}
        {/*</Form>*/}
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
              <tr>
                <th>Id</th>
                <th>User</th>
                <th>Created at</th>
              </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
              {listAnswer.length > 0 && listAnswer.map((val, index) => this.renderRow(val, index))}
              </tbody>
            </Table>
            {listAnswer.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Have no answer list</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { projectStore } = this.props;
    const { keyword } = this.state;
    if (keyword === "") {
      projectStore.getListAnswer();
    } else {
      projectStore.search(keyword, true);
    }
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { projectStore } = this.props;
    this.setState({ page: this.state.page - 1}, () => {
      projectStore.getListAnswer(this.state.page);
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    const { projectStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      projectStore.getListAnswer(this.state.page);
    });
  }
}

export default AnswerList;



// WEBPACK FOOTER //
// ./src/views/Projects/AnswerList.js